import { render, staticRenderFns } from "./index.vue?vue&type=template&id=449dad0f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('449dad0f')) {
      api.createRecord('449dad0f', component.options)
    } else {
      api.reload('449dad0f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=449dad0f", function () {
      api.rerender('449dad0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/TagsView/index.vue"
export default component.exports